import { Mail, Phone, MapPin, Linkedin, Twitter } from "lucide-react";
import { COMPANY, NAV_LINKS, SERVICES } from "@/lib/sipl-content";

export default function Footer() {
  return (
    <footer
      data-testid="site-footer"
      className="bg-sipl-primary text-white pt-16 pb-8 mt-0"
    >
      <div className="container-x grid grid-cols-1 md:grid-cols-12 gap-10">
        <div className="md:col-span-5">
          <div className="flex items-center gap-3">
            <div className="w-10 h-10 rounded-md bg-sipl-accent flex items-center justify-center font-heading text-white font-bold text-lg">
              S
            </div>
            <div>
              <div className="font-heading font-semibold text-lg">{COMPANY.short}</div>
              <div className="text-xs text-white/60 uppercase tracking-[0.2em]">
                Sunforce Infra Pvt. Ltd.
              </div>
            </div>
          </div>
          <p className="mt-5 text-white/70 text-sm leading-relaxed max-w-md">
            Renewable energy, waste management, rural infrastructure and
            project consultancy — engineered for India's sustainable decade.
          </p>
          <ul className="mt-6 space-y-2 text-sm text-white/80">
            <li className="flex items-start gap-2">
              <MapPin className="w-4 h-4 mt-0.5 text-sipl-accent" />
              {COMPANY.address}
            </li>
            <li className="flex items-center gap-2">
              <Phone className="w-4 h-4 text-sipl-accent" />
              <a href={`tel:${COMPANY.phone.replace(/\s/g, "")}`} className="hover:text-white">
                {COMPANY.phone}
              </a>
            </li>
            <li className="flex items-center gap-2">
              <Mail className="w-4 h-4 text-sipl-accent" />
              <a href={`mailto:${COMPANY.email}`} className="hover:text-white">
                {COMPANY.email}
              </a>
            </li>
          </ul>
        </div>

        <div className="md:col-span-3">
          <div className="text-xs uppercase tracking-[0.22em] text-white/50 mb-4">
            Navigate
          </div>
          <ul className="space-y-2.5 text-sm">
            {NAV_LINKS.map((l) => (
              <li key={l.href}>
                <a
                  href={l.href}
                  className="text-white/80 hover:text-sipl-accent"
                  data-testid={`footer-link-${l.label.toLowerCase()}`}
                >
                  {l.label}
                </a>
              </li>
            ))}
          </ul>
        </div>

        <div className="md:col-span-4">
          <div className="text-xs uppercase tracking-[0.22em] text-white/50 mb-4">
            Services
          </div>
          <ul className="space-y-2.5 text-sm">
            {SERVICES.map((s) => (
              <li key={s.id}>
                <a
                  href="#services"
                  className="text-white/80 hover:text-sipl-accent"
                  data-testid={`footer-service-${s.id}`}
                >
                  {s.title}
                </a>
              </li>
            ))}
          </ul>

          <div className="mt-6 flex items-center gap-3">
            <a
              href="https://www.linkedin.com/"
              target="_blank"
              rel="noopener noreferrer"
              className="w-9 h-9 rounded-md bg-white/10 hover:bg-sipl-accent flex items-center justify-center transition"
              aria-label="LinkedIn"
              data-testid="footer-social-linkedin"
            >
              <Linkedin className="w-4 h-4" />
            </a>
            <a
              href="https://twitter.com/"
              target="_blank"
              rel="noopener noreferrer"
              className="w-9 h-9 rounded-md bg-white/10 hover:bg-sipl-accent flex items-center justify-center transition"
              aria-label="Twitter"
              data-testid="footer-social-twitter"
            >
              <Twitter className="w-4 h-4" />
            </a>
          </div>
        </div>
      </div>

      <div className="container-x mt-12 pt-6 border-t border-white/10 flex flex-col md:flex-row gap-3 md:items-center md:justify-between text-xs text-white/55">
        <div>
          © {new Date().getFullYear()} {COMPANY.name}. All rights reserved.
        </div>
        <div className="flex gap-5">
          <span>CIN: {COMPANY.cin}</span>
          <span>MSME · GST Registered</span>
        </div>
      </div>
    </footer>
  );
}
